import React from 'react';
import moment from "moment";

type Props = {
    start: string,
    end: string,
};

const DatePeriod: React.FC<Props> = ({ start, end }) => <>{getDate(start, end)}</>;

const getDate = (start: string, end: string) => {
    if (start && !end) {
        return moment(start).format('DD MMM');
    }

    if (!start && end) {
        return moment(end).format('DD MMM');
    }

    if (start && end) {
        const sd = moment(start);
        const ed = moment(end);

        if (sd.diff(ed) < 0) {
            return sd.format('DD') + "-" + ed.format('DD MMM');
        }

        return sd.format('DD MMM');
    }

    return null;
};

export default DatePeriod;